import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import Portal from 'utils/portal/Portal';
import { areas } from 'constants/areas';
import { withAreaGetter } from 'providers/AreasConsumers';

import HeaderLinks from './header/HeaderLinks';
import HeaderPortal from 'components/layout/HeaderPortal';
import CompetenceOrderListBrowser from './CompetenceOrderListBrowser';
import useHistoryWithContext from 'components/menu/useHistoryWithContext';
import PermissionCheck from 'components/common/PermissionCheck';
import { ADMIN_COMPETENCE_ORDERS } from 'constants/rightsCodes';

const Route = ({ getElemByAreaKey }) => {
  const historyContext = useHistoryWithContext();

  const onAdd = () => {
    historyContext.push(`/competenceOrders/new`);
  };

  return (
    <Fragment>
      <HeaderPortal />
      <Portal container={getElemByAreaKey(areas.header)} />
      <Portal container={getElemByAreaKey(areas.headerLinks)}>
        <PermissionCheck authorizationCode={ADMIN_COMPETENCE_ORDERS} withForbiddenPage={false}>
          <HeaderLinks onAdd={onAdd} />
        </PermissionCheck>
      </Portal>
      <PermissionCheck authorizationCode={ADMIN_COMPETENCE_ORDERS}>
        <CompetenceOrderListBrowser />
      </PermissionCheck>
    </Fragment>
  );
};

Route.propTypes = {
  getElemByAreaKey: PropTypes.func.isRequired
};

export default withAreaGetter(Route);
